import { message } from 'antd';
import {
  compressImageFileIfNeeded as compressImageFileCore,
  IMAGE_UPLOAD_CONTENT_HINT,
  IMAGE_UPLOAD_MAX_BYTES,
  IMAGE_UPLOAD_SIZE_HINT,
  IMAGE_UPLOAD_SOURCE_MAX_BYTES,
  mergeImageUploadHint,
  type ImageUploadHintVariant,
} from '@mvl/image-upload/browser';

export {
  IMAGE_UPLOAD_CONTENT_HINT,
  IMAGE_UPLOAD_MAX_BYTES,
  IMAGE_UPLOAD_SIZE_HINT,
  IMAGE_UPLOAD_SOURCE_MAX_BYTES,
  mergeImageUploadHint,
  type ImageUploadHintVariant,
};

/** 管理后台上传前压缩：注入 antd 提示。 */
export async function compressImageFileIfNeeded(file: File): Promise<File> {
  return compressImageFileCore(file, {
    onStillOversized: () => {
      message.warning('图片已尽力压缩，体积仍可能略大于 2M。');
    },
  });
}
